import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';
import { Card, Price } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const CartSlider = ({ title , cart , children , defaultExpanded =false ,  })=>{
    const [isOpen, setIsOpen] = React.useState(defaultExpanded);
    const scrollHeight = React.useRef(0);
    const { currency  } = useIntl();
    const cartPrice = cart ? cart.prices.totalPrice : 0;
    var ref;
    const itemCount = (ref = cart === null || cart === void 0 ? void 0 : cart.numberOfItems) !== null && ref !== void 0 ? ref : 0;
    const handleButtonClick = ()=>{
        if (isOpen) {
            const distance = scrollHeight.current;
            const scrollTo = distance > window.scrollY ? window.scrollY : distance;
            window.scrollTo(0, Math.floor(scrollTo));
        } else {
            scrollHeight.current = window.scrollY;
        }
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ React.createElement(Card, {
        className: "cart-slider"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        className: classnames({
            'cart-slider--open': isOpen
        }),
        animate: isOpen ? 'open' : 'close',
        initial: "close",
        "data-t": "cart-slider"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "cart-slider__button",
        onClick: handleButtonClick,
        name: title
    }, /*#__PURE__*/ React.createElement("span", {
        className: "cart-slider__shopping-bag"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "shopping-bag"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "cart-slider__cart-label"
    }, title, " (", itemCount, ")"), /*#__PURE__*/ React.createElement(motion.span, {
        className: "cart-slider__button-price"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: cartPrice,
        currency: currency
    })), /*#__PURE__*/ React.createElement(motion.span, {
        variants: posedIcon,
        className: "cart-slider__icon",
        transition: {
            duration: itemCount
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        width: 16,
        height: 16,
        strokeWidth: 1,
        stroke: "#2b2e31",
        name: "chevron-down",
        className: classnames('cart-slider__chevron', {
            'cart-slider__chevron--rotated': isOpen
        })
    }))), /*#__PURE__*/ React.createElement(motion.div, {
        className: "cart-slider__content",
        variants: posedContent,
        transition: {
            duration: itemCount
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-slider__content-inner"
    }, children))));
};
const transition = {
    duration: 0.4,
    ease: [
        0.33,
        1,
        0.68,
        1
    ]
};
const posedContent = {
    close: {
        height: 0,
        display: 'none',
        transition
    },
    open: {
        height: 'auto',
        display: 'block',
        transition
    }
};
const posedIcon = {
    close: {
        rotate: 0,
        transition
    },
    open: {
        rotate: 180,
        transition
    }
};

export { CartSlider };
//# sourceMappingURL=CartSlider.js.map
